@if (store.order(); as order) {
  <customer-tracking-timeline [order]="order" />
  <div class="location-grid">
    <div>
      <div class="fw-bold">Delivery Location</div>
      <div>{{ order.dropoff.city }}, {{ order.dropoff.state }} {{ order.dropoff.zip }}</div>
    </div>
    <div>
      @if (order.tripStatus !== 'Delivered') {
        <div class="fw-bold">
          ETA
          @if (order.failReason) {
            <mat-icon class="text-error" aria-label="Load Delayed">warning</mat-icon>
          }
        </div>
        <div>{{ order.plannedETA | date: 'EEEE, MMMM d' }}</div>
        <div>{{ order.plannedETA | date: 'h:mm a' }}</div>
        @if (order.failReason) {
          <div class="text-error">Delayed reason: {{ order.failReason }}</div>
        }
      }
      @if (order.tripStatus === 'Delivered') {
        <div class="fw-bold">Delivered</div>
        <div>{{ order.actualArrivalTime | date: 'EEEE, MMMM d' }}</div>
        <div>{{ order.actualArrivalTime | date: 'h:mm a' }}</div>
      }
    </div>
  </div>
  <div class="bg-primary attributes">
    <button mat-flat-button class="tertiary mat-elevation-z2" (click)="openMap(order.currentPosition, order.dropoff)">
      Current Location
    </button>
    @if (order.attributes.quantity) {
      <div class="attribute-row">
        <span>Quantity</span>
        <span>{{ order.attributes.quantity }}</span>
      </div>
    }
    @if (order.attributes.weight) {
      <div class="attribute-row">
        <span>Weight</span>
        <span>{{ order.attributes.weight }}</span>
      </div>
    }
    @if (order.attributes.bolNumber) {
      <div class="attribute-row">
        <span>BOL</span>
        <span>{{ order.attributes.bolNumber }}</span>
      </div>
    }
    @if (order.attributes.shipTo) {
      <div class="attribute-row">
        <span>Ship to</span>
        <span>{{ order.attributes.shipTo }}</span>
      </div>
    }
  </div>
} @else if (store.error()) {
  <div class="error">
    <mat-icon>error</mat-icon>
    <p class="mat-title-large">{{ store.error() }}</p>
    <p>
      Looking for shipments from Specialized Solutions?
      <a href="https://ordercentral.crst.com/shipmenttrack" target="blank">Click here!</a>
    </p>
  </div>
}
